'use client';

import { useForm } from 'react-hook-form';
import type { SerialCodeFormTextProps } from '../../types';
import SerialCodeFormText from '../SerialCodeFormText/SerialCodeFormText';
import styles from './SerialCodeInput.module.scss';

export interface SerialCodeInputProps {
  initialValue?: string;
  onChange: (value: string) => void;
  SerialCodeFormTextComponent?: React.ComponentType<SerialCodeFormTextProps<{ serialCode: string }>>;
}

function SerialCodeInput({ initialValue = '', onChange, SerialCodeFormTextComponent }: SerialCodeInputProps) {
  const { getValues, control } = useForm({
    mode: 'onChange',
    defaultValues: {
      serialCode: initialValue ?? '',
    },
  });

  const updateValue = () => {
    onChange(getValues('serialCode'));
  };

  const FormComponent = SerialCodeFormTextComponent || SerialCodeFormText;

  return (
    <div className={styles.serialCodeInput}>
      <FormComponent name='serialCode' control={control} onChange={() => updateValue()} />
    </div>
  );
}

export default SerialCodeInput;
